import { Divider } from '@material-ui/core'

export default function DividerLine() {
    return (
        <section style={{marginTop: '15px'}}><Divider /></section>
    )
}